import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {
  Irop,
  IropService,
  WindowUtilsService
} from '@com-delta-idp/mnx-utils';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const IROP_ERROR_REDIRECT = new InjectionToken<string>(
  'IROP_ERROR_REDIRECT'
);

@Injectable({ providedIn: 'root' })
export class IropGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly irop: IropService,
    private windowUtilService: WindowUtilsService,
    @Inject(IROP_ERROR_REDIRECT) private readonly iropErrorRedirect: string
  ) {}

  canActivate(): Observable<boolean> {
    return this.irop.getContent().pipe(
      map((irop: Irop) => {
        if (irop?.iropType) {
          this.windowUtilService.location(this.iropErrorRedirect);
          return false;
        }
        return true;
      }),
      catchError(() => of(true))
    );
  }
}
